<template>
  <div>
    <c-search-box>
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-tab
      type="tabcard"
      align="left"
      :inlineLabel="true"
      :tabItems="tabItems"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :searchParam.sync="searchParam"
          :tabParam.sync="tabParam"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'emergency-relation-info',
  data() {
    return {
      searchParam: {
        plantCd: '',
        dataTypeCd: '1',
        useFlag: 'Y',
        innerFlag: 'Y',
      },
      editable: true,
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      tab: '1',
      tabItems: [
        // 비상연락체계도
        { name: '1', icon: 'folder', label: 'LBL0002686', component: () => import(`${'./emergencyRelationInfoDetail.vue'}`) },
        // 자위소방대조직도
        { name: '2', icon: 'folder', label: 'LBL0002687', component: () => import(`${'./emergencyRelationInfoDetail.vue'}`) },
        // 반별임무
        { name: '3', icon: 'folder', label: 'LBL0002688', component: () => import(`${'./emergencyRelationInfoDetail.vue'}`) },
        // 인근업체비상연락망
        { name: '4', icon: 'folder', label: 'LBL0002689', component: () => import(`${'./emergencyRelationInfoDetail.vue'}`) },
        // 집결지
        { name: '5', icon: 'folder', label: 'LBL0002690', component: () => import(`${'./emergencyRelationInfoDetail.vue'}`) },
        // 비상대피로
        { name: '6', icon: 'folder', label: 'LBL0002691', component: () => import(`${'./emergencyRelationInfoDetail.vue'}`) },
        // 응급상황 대응
        { name: '7', icon: 'phone_in_talk', label: 'LBL0002692', component: () => import(`${'@/pages/sop/eme/EmeContactManage.vue'}`) },
      ],
      tabParam: {
        dataTypeCd: '1',
        title: 'LBL0002686', // 비상연락체계도
      },
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
    tabClick(tab) {
      this.searchParam.dataTypeCd = tab.name;
      this.tabParam.dataTypeCd = tab.name;
      this.tabParam.title = tab.label;
    }
  }
};
</script>
